<template>
  <small class="breadcrumb">
    <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="px-0">
      <li
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
        class="breadcrumb__page"
        v-for="(breadcrumb, index) in breadcrumbs"
        :key="index"
      >
        <i v-if="index > 0" class="breadcrumb__arrow color-blue color-muted mx-1">/</i>
        <router-link
          v-if="breadcrumb.routerLink"
          :to="breadcrumb.routerLink"
          itemprop="item"
          class="breadcrumb__link btn--link py-1"
        >
          <span v-if="breadcrumb.type === 'address'" itemprop="name">
            {{ breadcrumb.title | ethAddress }}
          </span>
          <span v-else itemprop="name">{{ breadcrumb.title }}</span>
          <meta itemprop="position" :content="index + 1" />
        </router-link>
        <span v-else itemprop="item" class="breadcrumb__path color-blue color-muted py-1">
          <span v-if="breadcrumb.type === 'address'" itemprop="name">
            {{ breadcrumb.title | ethAddress }}
          </span>
          <span v-else itemprop="name">{{ breadcrumb.title }}</span>
          <meta itemprop="position" :content="index + 1" />
        </span>
      </li>
    </ol>
  </small>
</template>

<script>
export default {
  data: () => ({
    breadcrumbs: []
  }),

  methods: {
    // Set the breadcrumb pages based on current route
    buildBreadcrumbs() {
      if (!this.$route.matched.length) return []
      const { params, matched } = this.$route
      let paths = matched[matched.length - 1].path
      paths = paths.split("/")
      paths.shift()

      if (!paths.length) return []

      let fullLink = ""

      let breadcrumbs = []

      // Loop through all paths
      matched.forEach((match, i) => {
        // Add the current path to complete link
        let pathLink = "/"
        let path = paths[i]
        let pathAsParam

        if (path.charAt(0) === ":") {
          pathAsParam = params[path.slice(1)]
          pathLink += pathAsParam
        } else {
          pathLink += paths[i]
        }

        // Add this paths link to the full link
        fullLink += pathLink

        // If breadcrumb configured for this path
        if (match.meta && match.meta.breadcrumb) {
          // Breadcrumb to add to breadcrumbs array
          const breadcrumb = {}

          const breadcrumbTemplate = match.meta.breadcrumb

          // If this needs a link
          if (!breadcrumbTemplate.noLink) {
            breadcrumb.routerLink = fullLink
          }

          if (pathAsParam) {
            breadcrumb.title = pathAsParam
          } else {
            breadcrumb.title = breadcrumbTemplate.title
          }

          if (breadcrumbTemplate.type) {
            breadcrumb.type = breadcrumbTemplate.type
          }

          breadcrumbs.push(breadcrumb)
        }
      })

      // Remove link from last page (ie: current page);
      if (breadcrumbs.length) {
        delete breadcrumbs[breadcrumbs.length - 1].routerLink
      }

      return breadcrumbs
    }
  },

  watch: {
    $route: {
      handler(newRoute) {
        // For most, but not all components, route gets called twice on hard
        // page reload. Without this if statement, buildBreadCrumbs will be
        // called before $route has any useful paramaters. Do not remove
        if (newRoute && newRoute.matched.length) {
          this.breadcrumbs = this.buildBreadcrumbs()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.breadcrumb {
  display: block;

  &__page {
    display: inline-block;
  }

  &__arrow {
    cursor: default;
  }
}
</style>
